<div class="numpad-container">
    @if (numpadService.keypadOptions.showIncrementalStakes) {
        <ms-incremental-stakes />
    }
    <ms-numpad-keys class="numpad__numpad-keys" />
</div>
